import React from "react";
import TableDynamic from "../../components/PageDefault/TableDynamicFields";

const PayrollAndInvoicingProcedure = ({ status }) => {
  return (
    <TableDynamic
      comparision={"greater-than-or-equal-to"}
      stepNameComparision={"REGULARIZACIÓN"}
      status={status}
    />
  )
};

export default PayrollAndInvoicingProcedure;
